import React from 'react';
import { Grid } from '@material-ui/core';
import Link from 'next/link';
import {
  PauseModal, PauseModalBody, PauseModalFooter, PauseModalTitle,
} from '../../../../components/PauseModal';
import { PauseTypography } from '../../../../components/PauseTypography';
import { PauseTextButton } from '../../../../components/PauseTextButton';
import { PauseInteractiveButton } from '../../../../components/PauseInteractiveButton';

type CancelSubscriptionProps = {
  open: boolean,
  onClose: () => any,
  onCancelSubscription: () => any,
}
export const CancelSubscriptionConfirmationModal = ({
  open = false,
  onClose = () => null,
  onCancelSubscription = () => null,
}: CancelSubscriptionProps) => (
  // @ts-ignore
  <PauseModal
    open={open}
    onClose={onClose}
  >
    {/* @ts-ignore */}
    <PauseModalTitle
      title="Cancel subscription"
      onClose={onClose}
    />

    <PauseModalBody>
      <div css={(theme) => ({
        display: 'grid',
        gridGap: theme.spacing(1),
        gridAutoFlow: 'rows',
      })}
      >
        <PauseTypography color="pause.error.main" variant="caption">
          Cancelled subscriptions cannot be restored
        </PauseTypography>
        <PauseTypography>
          Cancelling a subscription will delete all members and their leaves records from Pause.
          Slack and calendar integrations will terminate.
          We suggest downloading your org’s
          {' '}
          <Link href="/settings">
            {/* @ts-ignore */}
            <PauseTextButton compact inline>leaves data here</PauseTextButton>
          </Link>
          .
        </PauseTypography>
      </div>
    </PauseModalBody>
    <PauseModalFooter>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PauseInteractiveButton color="error" onClick={onCancelSubscription}>
            Cancel
          </PauseInteractiveButton>
        </Grid>
      </Grid>
    </PauseModalFooter>
  </PauseModal>
);
